module.exports = __webpack_public_path__ + "img/1504774738.7ab4f09f.jpg";